import { Button, Checkbox } from 'flowbite-react';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { confirmLevelFn } from 'src/apis/position';
import { useToast } from 'src/context/ToastProvider';
import { Loader } from 'ui';
import { UIPosition } from 'types';

interface Props {
	selectedJobLevel: number;
	jobId: string;
	position?: UIPosition;
	onClick?: () => void;
}

const BottomButton = ({ selectedJobLevel, jobId, position, onClick }: Props) => {
	const navigate = useNavigate();
	const toast = useToast();

	const [isBoxChecked, setIsBoxChecked] = useState<boolean>(false);
	const levelConfirmFn = useMutation(['confirmLevel'], confirmLevelFn, {
		onSuccess() {
			navigate(`/positions/${jobId}/candidates`);
		},
		onError(err: any) {
			toast({
				title: err.response.data.message,
				type: 'error',
			});
		},
	});

	const handleConfirm = () => {
		if (onClick) {
			onClick();
			return;
		}

		// If auto recommendation is enabled, send lmsTechStack and subRole instead of level
		if (position?.autoRecommendationEnable && position?.lmsTechStack && Array.isArray(position.lmsTechStack) && position.lmsTechStack.length > 0) {
			levelConfirmFn.mutate({
				positionId: jobId,
				lmsTechStack: position.lmsTechStack.map((ts: any) => {
					// Ensure techStack is always a string (ObjectId)
					// Handle case where techStack might be an object
					let techStackId: string;
					const techStackValue = ts.techStack || ts;
					if (typeof techStackValue === 'string') {
						techStackId = techStackValue;
					} else if (techStackValue && typeof techStackValue === 'object') {
						// If it's an object, try to get _id or toString()
						const techStackObj = techStackValue as any;
						if (techStackObj._id) {
							techStackId = String(techStackObj._id);
						} else if (typeof techStackObj.toString === 'function') {
							techStackId = techStackObj.toString();
						} else {
							techStackId = String(techStackValue);
						}
					} else {
						techStackId = String(techStackValue);
					}
					return {
						techStack: techStackId,
						priority: ts.priority ?? 0,
					};
				}),
				subRole: position.subRole && Array.isArray(position.subRole) && position.subRole.length > 0 ? position.subRole : undefined,
			});
		} else {
			levelConfirmFn.mutate({ level: selectedJobLevel, positionId: jobId });
		}
	};

	return (
		<div className="py-2 w-full md:mt-20">
			<div className="flex gap-2 mb-4 items-center">
				<Checkbox
					color="purplePlaced"
					id="agreeCheckbox"
					className="text-[10px] sm:mt-[6px]"
					onChange={event => {
						setIsBoxChecked(event.target.checked);
					}}
				/>
				<label htmlFor="agreeCheckbox">I understand and agree: Once posted, the above details can't be edited.</label>
			</div>
			<div className="w-full">
				<Button
					color="purplePlaced"
					className="w-full"
					disabled={!isBoxChecked}
					onClick={handleConfirm}
				>
					{levelConfirmFn.isLoading ? <Loader /> : `Post`}
				</Button>
			</div>
		</div>
	);
};

export default BottomButton;
